/** 市场关联比赛快照版本 */
export const MARKET_CONTEST_SNAPSHOT_VERSION = 1;

/**
 * 解析 contestId：支持 v1 JSON 快照与历史纯比赛 id
 * @param {string} contestId
 * @returns {Object|null}
 */
export function parseMarketContest(contestId) {
  const raw = String(contestId ?? '').trim();
  if (!raw) return null;

  if (raw.startsWith('{')) {
    try {
      const data = JSON.parse(raw);
      if (data?.v === MARKET_CONTEST_SNAPSHOT_VERSION && data.matchId != null) {
        return {
          v: data.v,
          sportsSlug: String(data.sportsSlug ?? '').trim(),
          sportsLabel: String(data.sportsLabel ?? '').trim(),
          matchId: String(data.matchId),
          homeTeam: data.homeTeam,
          awayTeam: data.awayTeam,
          competition: data.competition,
          startTime: data.startTime,
          score: data.score,
        };
      }
    } catch {
      // 非法 JSON，按旧格式处理
    }
  }

  return { v: 0, matchId: raw };
}

/** 从 contestId 提取比赛 id（兼容旧数据） */
export function getMatchId(contestId) {
  return parseMarketContest(contestId)?.matchId ?? '';
}

/** 解析为数字 matchId，无效时返回 null */
export function resolveNumericMatchId(contestId) {
  const n = Number(getMatchId(contestId));
  return Number.isFinite(n) && n > 0 ? n : null;
}
